<template>
  <div id="main">
    <div class="main-panel">
      <div class="main-title">
        유산소 공유 자전거,<br v-if="$vuetify.breakpoint.smAndDown"/> 에브리바이크!
      </div>
      <div class="main-desc">
        자전거를 이용한 편리한 이동, 즐거운 운동을<br/>
        지금 에브리바이크로 시작해 보세요!
      </div>
      <div class="main-btn-bar" v-if="isMobile()">
        <v-btn depressed dark color="#10c5f7" class="btn-app-link-mobile"
               href="https://everybike.onelink.me/401D/b88d61c9">
          앱 다운로드
        </v-btn>
      </div>
      <div class="main-btn-bar" v-else>
        <v-btn depressed dark outlined class="btn-app-link" href="https://everybike.onelink.me/401D/99751df8">
          <v-icon left>mdi-apple</v-icon>
          App Store
        </v-btn>
        <v-btn depressed dark outlined class="btn-app-link" href="https://everybike.onelink.me/401D/10b10420">
          <v-icon left>mdi-google-play</v-icon>
          Google Play
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style lang="scss">
#main {
  width: 100%;
  min-height: 700px;
  color: white;
  text-align: left;
  background: url("../assets/main_img_puppy_bike@2x.png") no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;

  @media screen and (max-width: 960px) {
    text-align: center;
  }

  @media screen and (max-width: 420px) {
    min-height: 492px;
    text-align: center;
    background: url("../assets/main_img_puppy_bike_m.png") no-repeat center center;
    height: 0;
    width: 100%;
    padding-bottom: 153%;
    background-size: cover;
  }

  .btn-app-link {
    text-transform: none !important;
    width: 200px;
    height: 50px;
    margin-right: 12px;
    margin-left: 12px;
    margin-top: 24px;
    font-size: 19px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.29px;
    padding-bottom: 4px;

    &-mobile {
      width: 70%;
      height: 43px;
      border-radius: 3px;
      background-color: #10c5f7;
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      padding-bottom: 4px;
      margin-top: 19px;
    }
  }

  .main {
    &-panel {
      padding-top: 163px;
      max-width: 1280px;
      margin-left: auto;
      margin-right: auto;
      padding-left: 118px;
      @media screen and (max-width: 960px) {
        padding-top: 155px;
        padding-left: 0px;
      }
      @media screen and (max-width: 420px) {
        padding-top: 85px;
      }
    }

    &-title {
      font-size: 35px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      @media screen and (max-width: 960px) {
        font-size: 27px;
      }
    }

    &-desc {
      padding-top: 17px;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      @media screen and (max-width: 960px) {
        padding-top: 13px;
        font-size: 13px;
      }
    }
  }
}
</style>
